import { Button, Flex, Icon, useColorMode, FlexProps } from '@tonic-one/react';

import { AngleRightIcon } from '@tonic-one/react-icons';

export const ToRight = ({
  highlight,
  onClick: handleToRightClick,
  style = {},
}: {
  highlight: boolean;
  onClick: () => void;
  style?: Partial<FlexProps>;
}) => {
  const [colorMode] = useColorMode();
  return (
    <Flex flex={0} width="24px" align="center" mx="4px" {...style}>
      <Button
        variant="secondary"
        onClick={handleToRightClick}
        width="24px"
        size="sm"
      >
        <Icon
          as={AngleRightIcon}
          color={
            colorMode === 'dark'
              ? highlight
                ? 'blue:50'
                : 'white:primary'
              : highlight
                ? 'blue:50'
                : 'black:primary'
          }
        />
      </Button>
    </Flex>
  );
};
